import { defineStore } from 'pinia'
import { useAuthStore } from '@/stores/user/auth'
import { useToastsStore } from '@/stores/notifications/toasts'
import { useGinnelStore } from '@/stores/ginnels/ginnel'
import { getResponse, getError } from '@/composables/api'
import router from '@/router'
import axios from 'axios'

export const useFilesStore = defineStore({
   id: 'ginnel-files',
   state: () => ({
      addedFile: null,

      updatedFileID: null,
      updatedFile: {},
      updatedFileType: {},
      deletedFileID: null,

      tagged: [],

      storeAuth: useAuthStore(),
      storeToasts: useToastsStore(),
      storeGinnel: useGinnelStore(),
   }),
   actions: {
      /**
         * Function: add
         * @description Sends a post requiest to the API
         * to add a file.
         *
         * @param {Object} formData
      */
      add(formData) {
			axios.post('ginnel/file', formData).then(response => {
            this.addedFile = getResponse(response)

            // Add the file to the ginnel files array
            this.storeGinnel?.ginnel?.files.push(this.addedFile)

            router.push({ name: 'collection.ginnel', params: { ginnel_id: formData.ginnel_id }, query: { file: parseInt(this.addedFile?.file_id) } })

            this.storeGinnel.postRequestCleanup(formData.ginnel_id, 'A new file has been added.')
			}).catch((response) => {
            this.storeToasts.sendToast(getError(response), 'danger')
         })
      },
      /**
         * Function: update
         * @description Sends a put requiest to the API
         * to update a file.
         *
         * @param {String} content
         * @param {String} file_type
         * @param {Number} file_id
         * @param {Number} ginnel_id
      */
      update(content, file_type, file_id, references, ginnel_id) {
         this.storeGinnel.waiting = true
         let params = {
            content: content,
            file_type: file_type,
            file_id: file_id,
         }

         // Add references to payload if they exist
         if(references?.length) params.references = references

         axios.put('ginnel/file', params).then(response => {
            this.storeGinnel.waiting = false
            this.updatedFileID = file_id
            this.updatedFile = {
               file_id: file_id,
               datetime: getResponse(response)
            }

            this.storeToasts.sendToast('The file has been updated.')

            let file = this.storeGinnel.ginnel.files.filter(ginnelFile => ginnelFile.file_id == file_id)?.[0]

            if(file && references?.length) {
               file.references.slice(0, file.references.length)
               file.references = JSON.stringify(references)
            }

         }).catch((response) => {
            this.storeGinnel.waiting = false
            this.storeToasts.sendToast(getError(response) ?? 'Unknown Error.', 'danger')
         })
      },
      clearFileUpdate() {
         this.updatedFileID = null
      },
      /**
         * Function: delete
         * @description Sends a delete requiest to the API
         * to delete a file.
         *
         * @param {Number} file_id
         * @param {Number} ginnel_id
      */
      delete(file_id, ginnel_id) {
         let params = {
             file_id: file_id
         };
         axios.delete('ginnel/file', { params: params }).then((response) => {
             this.storeGinnel.postRequestCleanup(ginnel_id, 'The file has been deleted.');
             this.deletedFileID = file_id;

             // Find the index of the file in the array
             const fileIndex = this.storeGinnel.ginnel.files.findIndex(file => file.file_id == file_id);
             if (fileIndex !== -1) {
                 // Remove the file from the array using splice
                 this.storeGinnel.ginnel.files.splice(fileIndex, 1);
             }

             router.push({ name: 'collection.ginnel', params: { ginnel_id: ginnel_id } });
         }).catch((error) => {
             this.storeToasts.sendToast(getError(error), 'danger');
         });
     },
      /**
         * Function: updateName
         * @description Sends a put requiest to the API
         * to update a file name.
         *
         * @param {Object} payload
      */
      updateName(payload) {
         this.storeGinnel.waiting = true

			axios.put('ginnel/file/name', payload)
         .then(response => {
            this.storeGinnel.waiting = false
            this.updatedFileType = payload.file_type
			})
         .catch((response) => {
            this.storeGinnel.waiting = false
            this.storeToasts.sendToast(getError(response), 'danger')
            this.storeGinnel.get(payload.ginnel_id, true)
         })
      },
      taggedFiles() {
         axios.get('tagged/files')
         .then((response) => {
            this.tagged = getResponse(response)
         })
      },
      /**
         * Function: updatePositions
         * @description Sends a put requiest to the API
         * to update the file positions.
         *
         * @param {Array} params [{file_id: file_id, position: position}]
         * @param {Number} ginnel_id
      */
      updatePositions(params, ginnel_id) {
			axios.put('ginnel/files/positions', params).then(response => {
            this.storeToasts.sendToast('The file positions have been updated.')
         }).catch(response => {
            this.storeToasts.sendToast(getError(response), 'danger')
         })
      },
   }
})